/* eslint-disable react/destructuring-assignment */

import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';

import { DataRequestActionTypes } from '../../../constants/actionTypes';
import { FormId } from '../../../constants/formId';
import FormModal from '../../modal/formModal';

interface SendEventFormOwnProps {
  eventId: string;
  // onSuccessCallback?: () => void;
}

// eslint-disable-next-line react/prefer-stateless-function
export default class SendToNlpForm extends React.Component<SendEventFormOwnProps> {
  // constructor(props: any) {
  //   super(props);
  // }

  public render() {
    return (
      <FormModal
        formId={FormId.NlpForm}
        formTitle="Send to NLP"
        submitActionType={DataRequestActionTypes.SendToNLP}
        reduxData={{ eventId: this.props.eventId }}
        buttonIcon={faPaperPlane}
        invertedButtonColours
        // onSuccessCallback={this.props.onSuccessCallback}
      >
        <div>Are you sure to upload all the participants?</div>
      </FormModal>
    );
  }
}
